import ThCalendarDay from "./ThCalendarDay";
import { images } from "@img/imagesMap";
import type * as type from "@vTypes";
import { WEEKDAY_SHORT_SUN_FIRST } from "@/utils/dayUtill";

export type TableHeaderWantedProps = {
  defaultShiftCode: type.Type_availableShifts[];
  nursesCount: number;
  currentYear: number;
  currentMonth: number;
  holidayDates: string[];
  onlyView: boolean;
  prefix?: string;
  /** 근무표 만들기와 동일: RN/AN/ETC 유지 + 이름·G·경력 정렬 */
  onSort?: (key: "name" | "grade" | "experience") => void;
  /**
   * true: 정렬은 `이름`만 노출(바디에 G·경력 열이 없을 때 헤더와 달력 열 맞춤)
   * false/미지정: onSort 시 이름·G·경력 버튼 전부 표시
   */
  nameColumnOnly?: boolean;
};

function TableHeader_wanted({
  defaultShiftCode,
  nursesCount,
  currentYear,
  currentMonth,
  holidayDates,
  onlyView,
  prefix,
  onSort,
  nameColumnOnly = false,
}: TableHeaderWantedProps) {
  const lastDay = new Date(currentYear, currentMonth, 0).getDate();
  const firstDayFactor = new Date(currentYear, currentMonth - 1, 1).getDay();
  const formatDate = (year: number, month: number, day: number) => {
    const mm = String(month).padStart(2, "0"); // '02'
    const dd = String(day).padStart(2, "0"); // '06'
    return `${year}-${mm}-${dd}`;
  };

  if (!defaultShiftCode || defaultShiftCode.length === 0) return;
  return (
    <div className="flex border-b border-b-border sticky -top-6 bg-white z-9">
      <div className="rt_nurseInfo_flexWrap">
        {/* 인원수 */}
        <div className="flex justify-center gap-[6px] text-[14px] text-[#939399] !pb-[10px] leading-[--shiftCode_size] padding_hover_bg_vertical !items-end">
          <img
            src={images.user}
            alt=""
            className=""
            style={{ height: "1em" }}
          />
          {nursesCount}
        </div>
        {/* 이름 · G · 경력 (onSort 시 근무표 만들기와 동일 정렬) */}
        <div className="rt_nurse_name padding_hover_bg_vertical !items-end !pb-[10px]">
          {onSort && nameColumnOnly ? (
            <div className="text-[14px] font-pretendard text-[#999999] flex justify-center !w-[70px] !min-w-[70px] !items-end">
              <button
                type="button"
                className="cursor-pointer underline decoration-[#999999] underline-offset-2 text-center"
                onClick={() => onSort("name")}
              >
                이름
              </button>
            </div>
          ) : onSort ? (
            <div className="text-[14px] font-pretendard text-[#999999] flex items-end justify-center gap-1">
              <button
                type="button"
                className="cursor-pointer underline decoration-[#999999] underline-offset-2 text-center !min-w-[52px]"
                onClick={() => onSort("name")}
              >
                이름
              </button>
              <button
                type="button"
                className="cursor-pointer underline decoration-[#999999] underline-offset-2 text-center !min-w-[24px]"
                onClick={() => onSort("grade")}
              >
                G
              </button>
              <button
                type="button"
                className="cursor-pointer underline decoration-[#999999] underline-offset-2 text-center !min-w-[36px]"
                onClick={() => onSort("experience")}
              >
                경력
              </button>
            </div>
          ) : (
            <div className="text-[14px] font-pretendard text-[#999999] flex justify-center !w-[70px] !min-w-[70px]">
              이름
            </div>
          )}
        </div>
      </div>

      <div className={`flex ${onlyView ? "py-[2px] pl-[1px]" : ""} pl-[1px]`}>
        {Array.from({ length: lastDay }, (_, i) => {
          const dateStr = formatDate(currentYear, currentMonth, i + 1);
          const dayIndex = (i + firstDayFactor) % 7;
          const isHoliday = holidayDates.includes(dateStr);
          const holiday = isHoliday
            ? "holiday"
            : (i + firstDayFactor) % 7 === 6
              ? "sat"
              : (i + firstDayFactor) % 7 === 0
                ? "sun"
                : "";
          return (
            <ThCalendarDay
              key={i}
              day={i + 1}
              holiday={holiday}
              weekDay={WEEKDAY_SHORT_SUN_FIRST[dayIndex]}
              prefix={prefix}
            />
          );
        })}
      </div>

      <div className="rt_rowSummary_flexWrap">
        <div className="rt_whiteSpace rt_bg_hover_row"></div>
        <div className="rt_whiteSpace rt_bg_hover_row"></div>
      </div>
    </div>
  );
}

export default TableHeader_wanted;
